































import Vue from "vue";
import { IState, ApplicationState } from "../store/state";
import { comment } from "../store/actions";

interface NoBoxComputed {
  title: string;
  text: string;
  commentLabel: string;
  submitText: string;

  sent: boolean;
  sendingClass: any;
  postUrl: string;
  commentValid: any;
}

interface NoBoxData {
  comment: {
    value: string;
    isValid: boolean;
    isDirty: boolean;
  };
}

interface NoBoxMethods {
  postComment(): void;
}

export default Vue.extend<NoBoxData, NoBoxMethods, NoBoxComputed, {}>({
  data() {
    return {
      comment: {
        value: "",
        isValid: false,
        isDirty: false
      }
    };
  },
  watch: {
    comment: {
      handler(newComment) {
        this.comment.isDirty =
          newComment.isDirty || (newComment.value && newComment.value.trim())
            ? true
            : false;
        this.comment.isValid = this.comment.isDirty;
      },
      deep: true
    }
  },
  methods: {
    postComment() {
      if (this.comment.isValid && !(this.$store.state as IState).sending) {
        this.$store.dispatch(
          comment({
            comment: this.comment.value,
            nextState: ApplicationState.THANKS
          })
        );
      }
    }
  },
  computed: {
    sent() {
      return this.$store.state.sent;
    },
    sendingClass() {
      return {
        "kb-page-rating-rate__form--sending": this.$store.state.sending
      };
	},
	title() {
	  return this.$store.state.sent
        ? (this.$store.state as IState).strings.no.sent.title
        : (this.$store.state as IState).strings.no.form.title;
	},
    text() {
      return this.$store.state.sent
        ? (this.$store.state as IState).strings.no.sent.text.replace(/\n/g, '<br>')
        : (this.$store.state as IState).strings.no.form.text.replace(/\n/g, '<br>');
    },
    commentLabel() {
      return (this.$store.state as IState).strings.no.form.label;
	},
	submitText() {
	  return (this.$store.state as IState).strings.no.form.submit;
	},
    postUrl() {
      return this.$store.state.commentUrl;
    },
    commentValid() {
      return {
        "kb-page-rating-rate__form-comment--invalid":
          this.comment.isDirty && !this.comment.isValid
      };
    }
  }
});
